module.exports = __webpack_public_path__ + "img/login.b1498283.png";